import type { DelayedQuote } from '@benzinga/quotes-manager';

export type PortfolioQuoteBarDetail = {
  quotes?: Record<string, DelayedQuote>;
  tickers: string[];
};

type PortfolioQuoteBarListener = (detail: PortfolioQuoteBarDetail | null) => void;

let currentDetail: PortfolioQuoteBarDetail | null = null;
const listeners = new Set<PortfolioQuoteBarListener>();

export function publishPortfolioQuoteBar(detail: PortfolioQuoteBarDetail | null): void {
  currentDetail = detail;
  listeners.forEach(listener => listener(detail));
}

export function subscribePortfolioQuoteBar(listener: PortfolioQuoteBarListener): () => void {
  listeners.add(listener);
  listener(currentDetail);
  return () => {
    listeners.delete(listener);
  };
}
